<template>
  <div class="virtual-cursor"
       :style="[cursorPos, cursorDynamicStyle]"
       :class="cursorClass"
       v-show="visible && controlEnabled">
    <div class="cursor-point"></div>
    <div class="cursor-label" v-if="label">{{ label }}</div>
    <div class="action-progress" v-if="isFisting"></div>
    <div class="scroll-icon" v-if="isScrolling">↕️</div>
    <div class="cursor-magnet-icon" v-if="isSnapped" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: 'VirtualCursor',
  props: {
    visible: { type: Boolean, default: true },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    label: { type: String, default: '' },
    isClicking: { type: Boolean, default: false },
    isScrolling: { type: Boolean, default: false },
    isSnapped: { type: Boolean, default: false },
    isFisting: { type: Boolean, default: false },
    isInactive: { type: Boolean, default: false },
    controlEnabled: { type: Boolean, default: false },
  },
  computed: {
    cursorPos() {
      return { left: this.x + 'px', top: this.y + 'px' }
    },
    cursorDynamicStyle() {
      return { transition: 'none' }
    },
    cursorClass() {
      return {
        clicking: this.isClicking,
        scrolling: this.isScrolling,
        snapped: this.isSnapped,
        fisting: this.isFisting,
        inactive: this.isInactive,
      }
    }
  }
}
</script>

<style scoped>
.virtual-cursor {
  position: fixed;
  z-index: 10040;
  pointer-events: none;
  width: 30px;
  height: 30px;
  transform: translate(-50%, -50%);
}
.inactive > div { opacity: 0.15; transition: opacity 0.5s ease; }
.cursor-point {
  width: 100%; height: 100%;
  border-radius: 50%;
  background: rgba(0, 242, 248, 0.2);
  border: 3px solid #00F2F8;
  box-shadow: 0 0 20px #00F2F8;
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
}
.clicking .cursor-point { background: rgba(255, 50, 50, 0.8); border-color: #ff3333; transform: translate(-50%, -50%) scale(0.8); }
.scrolling .cursor-point { border-color: #ffff00; background: yellow; border-radius: 0; }
.snapped .cursor-point { border-color: #00ff00; background: rgba(0, 255, 0, 0.4); transform: translate(-50%, -50%) scale(0.6); }
.fisting .cursor-point { background: rgba(255, 80, 80, 0.8); transform: translate(-50%, -50%) scale(0.5); }
.cursor-label {
  position: absolute; top: 35px; left: 35px;
  background: rgba(0,0,0,0.8); color: #fff; padding: 4px 8px; border-radius: 4px;
  font-size: 12px; white-space: nowrap; border: 1px solid #00F2F8;
}
.action-progress {
  position: absolute; width: 38px; height: 38px;
  border-radius: 50%; border: 2px solid rgba(255,255,255,0.2); border-top-color: #00F2F8;
  top: -5px; left: -5px; transform: translate(-50%, -50%);
  animation: spin 0.3s linear forwards;
}
.scroll-icon {
  position: absolute; top: -25px; left: 50%;
  transform: translateX(-50%); font-size: 16px;
}
.cursor-magnet-icon {
  position: absolute;
  top: -14px;
  left: 50%;
  width: 7px;
  height: 7px;
  border: 1px solid #65f6cf;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(101, 246, 207, 0.15);
  transform: translateX(-50%);
}
@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}
</style>
